export const SET_ENCRYPTION_KEY = 'SET_ENCRYPTION_KEY';
export const SET_VIDEO_CURRENT_KEY = 'SET_VIDEO_CURRENT_KEY';
